import { createSlice } from "@reduxjs/toolkit";

import { type Auth } from "../../../@types/store";
import Authenticator from "../../../lib/domain/authenticator";
import { AUTH_VIEW } from "../../../utils/constants";

const initialState: Auth = {
  isAuthenticated: Authenticator.isAuthenticated(),
  // isAuthenticated: true,
  // user: Authenticator.getUser(),
  user: { role: "admin" },
  isLoading: false,
  isLoginPage: true,
  isLoginForm: false,
  activePage: AUTH_VIEW.REGISTER,
};
export const sliceKey = "auth";

export const authSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    login: (state, { payload }) => {
      try {
        Authenticator.login(payload);
        state.isAuthenticated = Authenticator.isAuthenticated();

        // state.user = Authenticator.getUser();
        // state.isAuthenticated = payload?.isAuthenticated;
        // state.user = payload?.user;
      } catch (e) {
        console.log(e);
      }
    },
    logout: (state) => {
      try {
        Authenticator.logout();
        state.isAuthenticated = Authenticator.isAuthenticated();
        // state.user = Authenticator.getUser();
      } catch (e) {
        console.log(e);
      }
    },
    setLoading: (state, { payload }) => {
      try {
        state.isLoading = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setAuthLandingState: (state, { payload }) => {
      try {
        state.isLoginPage = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setToggleLoginForm: (state, { payload }) => {
      try {
        state.isLoginForm = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setAuthView: (state, { payload }) => {
      try {
        state.activePage = payload;
      } catch (e) {
        console.log(e);
      }
    },
  },
});

export const {
  login,
  logout,
  setLoading,
  setAuthLandingState,
  setToggleLoginForm,
  setAuthView,
} = authSlice.actions;

export default authSlice.reducer;
